// Standard library imports
import React, { useState, useEffect } from 'react';

// External library imports
import { toast } from 'react-toastify';
import _ from 'lodash';
// Internal module imports
import TestLogs from './TestLogsTable';
import TabsComponent from '../../../components/Tabs/Tabs';
import Control from './Control';
import ScheduleFCRV1 from './ScheduleFCRV1';
import ScheduleFCRV2 from './ScheduleFCRV2';
import ScheduleFRRV1 from './ScheduleFRRV1';
import ScheduleFRRV2 from './ScheduleFRRV2';
import { EdgeService } from '../../../services/EdgeService';
import { useLoader } from '../../../hooks';
import { getEdgeCodeVersion } from '../../../utils/edgeHelper';

const ScheduleTestIndex = ({ edgeData, scheduleModal, setScheduleModal, setRedirectTo, setTestLogs, setSelectedIndex, baseCommands }) => {
    const [edgeVersion] = useState(getEdgeCodeVersion(edgeData.edgeVersion));
    const [startLoader, stopLoader] = useLoader();
    const [market, setMarket] = useState('');
    const [edge, setEdge] = useState(edgeData);

    useEffect(() => {
        if (edgeData?.deviceId) {
            getScheduleTestMarket();
        }
    }, [edgeData?.deviceId]);

    const getScheduleTestMarket = () => {
        EdgeService.GetScheduleTestMarket(
            {
                deviceId: edgeData?.deviceId,
            },
            startLoader,
            handleGetScheduleTestMarketSuccess,
            handleError,
            stopLoader
        );
    };

    const handleGetScheduleTestMarketSuccess = ({ data }) => {
        setMarket(_.get(data, ['data', 'biddingMarket'], ''));
        setEdge({ ...edge, market: _.get(data, ['data', 'biddingMarket'], '') });
    };

    const handleError = (err) => {
        if (err && err.response) toast.error(err.response.data.message);
    };

    const scheduleTabs = [
        ...(market?.includes('FCR') || market?.includes('FFR')
            ? [
                  ...(edgeVersion < 40500 || edgeVersion === 0
                      ? [
                            {
                                name: 'FCR Schedule Test (V1)',
                                component: (
                                    <ScheduleFCRV1
                                        edgeData={edge}
                                        setScheduleModal={setScheduleModal}
                                        setRedirectTo={setRedirectTo}
                                        setTestLogs={setTestLogs}
                                        setSelectedIndex={setSelectedIndex}
                                        baseCommands={baseCommands}
                                    />
                                ),
                            },
                        ]
                      : []),
                  ...(edgeVersion >= 40500 || edgeVersion === 0
                      ? [
                            {
                                name: 'FCR Schedule Test (V2)',
                                component: (
                                    <ScheduleFCRV2
                                        edgeData={edge}
                                        setScheduleModal={setScheduleModal}
                                        setRedirectTo={setRedirectTo}
                                        setTestLogs={setTestLogs}
                                        setSelectedIndex={setSelectedIndex}
                                        baseCommands={baseCommands}
                                    />
                                ),
                            },
                        ]
                      : []),
              ]
            : []),
        ...(market?.includes('FRR') && market?.includes('aFRR')
            ? [
                  {
                      name: 'aFRR Signal Test',
                      component: (
                          <ScheduleFRRV1
                              edgeData={edge}
                              setScheduleModal={setScheduleModal}
                              setRedirectTo={setRedirectTo}
                              setTestLogs={setTestLogs}
                              setSelectedIndex={setSelectedIndex}
                              baseCommands={baseCommands}
                              market={market}
                          />
                      ),
                  },
                  ...(edgeVersion >= 40500 || edgeVersion === 0
                      ? [
                            {
                                name: 'aFRR Schedule Test',
                                component: (
                                    <ScheduleFRRV2
                                        edgeData={edge}
                                        setScheduleModal={setScheduleModal}
                                        setRedirectTo={setRedirectTo}
                                        setTestLogs={setTestLogs}
                                        setSelectedIndex={setSelectedIndex}
                                        baseCommands={baseCommands}
                                        market={market}
                                    />
                                ),
                            },
                        ]
                      : []),
              ]
            : []),
        ...(market?.includes('FRR') && market?.includes('mFRR')
            ? [
                  {
                      name: 'mFRR Signal Test',
                      component: (
                          <ScheduleFRRV1
                              edgeData={edge}
                              setScheduleModal={setScheduleModal}
                              setRedirectTo={setRedirectTo}
                              setTestLogs={setTestLogs}
                              setSelectedIndex={setSelectedIndex}
                              baseCommands={baseCommands}
                              market={market}
                          />
                      ),
                  },
                  ...(edgeVersion >= 40500 || edgeVersion === 0
                      ? [
                            {
                                name: 'mFRR Schedule Test',
                                component: (
                                    <ScheduleFRRV2
                                        edgeData={edge}
                                        setScheduleModal={setScheduleModal}
                                        setRedirectTo={setRedirectTo}
                                        setTestLogs={setTestLogs}
                                        setSelectedIndex={setSelectedIndex}
                                        baseCommands={baseCommands}
                                        market={market}
                                    />
                                ),
                            },
                        ]
                      : []),
              ]
            : []),
    ];

    const tabs = [
        ...scheduleTabs,
        ...(edgeVersion >= 40400
            ? [
                  {
                      name: 'Equipment Testing',
                      component: (
                          <>
                              <Control edgeData={edge} baseCommands={baseCommands} setScheduleModal={setScheduleModal} edgeVersionValue={edgeVersion} />
                          </>
                      ),
                  },
              ]
            : []),
        {
            name: 'Predefined Test',
            component: (
                <>
                    <TestLogs market={edge.market} setScheduleModal={setScheduleModal} />
                </>
            ),
        },
    ];

    return (
        <div>
            <TabsComponent selectedIndex={scheduleModal?.tabIdx ? scheduleModal?.tabIdx : 0} tabs={tabs} />
        </div>
    );
};

export default ScheduleTestIndex;
